import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_arrow_up",
  "use": "icon-ic_arrow_up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_arrow_up\">\n<path d=\"M12 9.52532L4.22177 17.3035L2.80757 15.8893L11.6464 7.05037C11.8417 6.85511 12.1583 6.85511 12.3536 7.05038L21.1924 15.8893L19.7782 17.3035L12 9.52532Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol